import { render, staticRenderFns } from "./Medicamento.vue?vue&type=template&id=2214cbb2&scoped=true&"
import script from "./Medicamento.vue?vue&type=script&lang=js&"
export * from "./Medicamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214cbb2",
  null
  
)

export default component.exports